import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';

import metadata from './AdditionalInformationComponent.metadata.json5';
import styles from '../../../pages/Accountant/AccountantPage.module.scss';
import PublicationComponent from '../Subcomponents/Publication/PublicationComponent';

function AdditionalInformationComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('AdditionalInformationComponent');
    const modelVM = _.get(submissionVM, pathUpdated)

    modelVM.value.isValidationReq = true

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        exp4: {
            visible: !_.isUndefined(modelVM.value.doeTheAppAccRemIE3) && modelVM.value.doeTheAppAccRemIE3
        },
        exp6: {
            visible: !_.isUndefined(modelVM.value.doeTheAppEntIntjoVen5) && modelVM.value.doeTheAppEntIntjoVen5
        },
        exp9: {
            visible: !_.isUndefined(modelVM.value.doeTheAppHavAffAssWit8) && modelVM.value.doeTheAppHavAffAssWit8
        },
        exp11: {
            visible: !_.isUndefined(modelVM.value.doeTheAppHavAFinInt10) && modelVM.value.doeTheAppHavAFinInt10
        },
        exp13: {
            visible: !_.isUndefined(modelVM.value.doeAnyCliHavAFinInt12) && modelVM.value.doeAnyCliHavAFinInt12
        },
        exp19: {
            visible: !_.isUndefined(modelVM.value.doeTheAppProItComRel18) && modelVM.value.doeTheAppProItComRel18
        },
        ifYesDoeTheAppHavWri22: {
            visible: !_.isUndefined(modelVM.value.doeTheAppUseAWriSer21) && modelVM.value.doeTheAppUseAWriSer21
        },
        exp25: {
            visible: !_.isUndefined(modelVM.value.isTheAppAMemInGoo24) && modelVM.value.isTheAppAMemInGoo24
        },
        ifOthExp29: {
            visible: !_.isUndefined(modelVM.value.typOfWor28) && modelVM.value.typOfWor28
        },
        publicationsHeader: {
            visible: !_.isUndefined(modelVM.value.doeTheAppPubANewOr32) && modelVM.value.doeTheAppPubANewOr32
        },
        publicationComponent: {
            visible: !_.isUndefined(modelVM.value.doeTheAppPubANewOr32) && modelVM.value.doeTheAppPubANewOr32,
            data: modelVM.publications,
            updateWizardData,
            submissionVM,
            CompanyContractDetailsPath: `${pathUpdated}.publications`
        },
        havYouOrAnyOfFinInv: {
            visible: false
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            publicationComponent: PublicationComponent
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

AdditionalInformationComponent.propTypes = wizardProps;
export default withRouter(AdditionalInformationComponent);
